module.exports = __webpack_public_path__ + "img/honor3.jpg";